import { ActionIcon, Group, Highlight, Paper, Tooltip } from "@mantine/core";
import { IconEdit, IconTrash } from "@tabler/icons-react";
import { generatePath, Link } from "react-router";
import { ROUTES } from "../../../../routes";
import { SiteLicense } from "../../../../types/api.types";
import type { Site } from "../../../../utils/backend-types";
import { useShouldShowStaffView } from "../../../StaffViewToggle/useShouldShowStaffView";
import { LicenseIcon } from "../SetupProcessItem/LicenseIcon";

interface SiteItemProps {
  projectId: string;
  showLicense?: boolean;
  site: Site;
  isLight: boolean;
  isPremium: boolean;
  highlightTerm: string;
  onClickEdit: (site: Site) => void;
  onDelete: (site: Site) => void;
}

function SiteItem({
  projectId,
  showLicense,
  site,
  isLight,
  isPremium,
  highlightTerm,
  onClickEdit,
  onDelete
}: SiteItemProps) {
  const { shouldShowStaffView } = useShouldShowStaffView();
  const path = generatePath(ROUTES.site.entry, {
    projectId: projectId,
    siteId: site.id.toString()
  });

  return (
    <Paper className="SiteItem" p="md" shadow="none" withBorder>
      <Group gap="lg" justify="space-between" mih={26}>
        <Group>
          {showLicense && (
            <LicenseIcon
              iconProps={{ size: "1.5em" }}
              license={
                isPremium
                  ? SiteLicense.premium
                  : isLight
                    ? SiteLicense.light
                    : SiteLicense.standard
              }
            />
          )}
          <Link to={path}>
            <Highlight fw={500} highlight={highlightTerm}>
              {site.name}
            </Highlight>
          </Link>
        </Group>
        <Group gap="xs">
          <Tooltip label="Liegenschaft bearbeiten">
            <ActionIcon
              c="info"
              size="xs"
              variant="transparent"
              onClick={() => onClickEdit(site)}
            >
              <IconEdit />
            </ActionIcon>
          </Tooltip>
          {shouldShowStaffView && (
            <Tooltip label="Liegenschaft löschen">
              <ActionIcon
                c="error"
                size="xs"
                variant="transparent"
                onClick={() => onDelete(site)}
              >
                <IconTrash />
              </ActionIcon>
            </Tooltip>
          )}
        </Group>
      </Group>
    </Paper>
  );
}

export { SiteItem, SiteItemProps };
